import { useNavigate, useParams } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '#components/Button'
import { Icon } from '#components/Icon'
import { Tooltip } from '#components/Tooltip'
import { useAuth } from '#hooks/useAuth'
import { useOnboardingStatus } from '#pages/Onboarding/hooks/useOnboardingStatus'

import styles from './styles.module.scss'

export const OnboardingNudge = (): React.JSX.Element | null => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useAuth()
  const allParams = useParams({ strict: false })
  const companyId = 'companyId' in allParams ? allParams.companyId : undefined
  const { onboardingCompleted, isLoading } = useOnboardingStatus()

  // Only show when the current user's own company matches the viewed company
  const isOwnCompany = !!user?.companyId && user.companyId === companyId

  if (!isOwnCompany || isLoading || onboardingCompleted || !companyId) return null

  return (
    <Tooltip content={t('Complete your onboarding')} trigger="element">
      <Button
        variant="ghost"
        className={styles.nudge}
        onPress={() =>
          void navigate({
            to: '/companies/$companyId/onboarding',
            params: { companyId },
          })
        }
        aria-label={t('Complete your onboarding')}
        data-testid="onboarding-nudge"
      >
        <Icon name="check-circle" width="18" height="18" />
      </Button>
    </Tooltip>
  )
}
